/**
 * Moves the highlighted entry in the search-suggestion dropdown.
 *
 * `current` is `-1` whenever nothing is highlighted, and that is the resting
 * state: the dropdown deliberately does not auto-highlight, so pressing Enter
 * submits the typed query to the search page instead of opening the first hit
 * (NF-362). Both directions therefore have to treat `-1` as "outside the
 * list" — the obvious `(current - 1 + length) % length` returns `length - 2`
 * from there and silently skips the last suggestion.
 */
export const stepSuggestionIndex = (
	current: number,
	length: number,
	direction: "next" | "previous"
): number => {
	if (length <= 0) {
		return -1;
	}
	if (direction === "next") {
		return current < 0 ? 0 : (current + 1) % length;
	}
	return current <= 0 ? length - 1 : current - 1;
};
